<template>
  <!-- Sidebar -->
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner slimscroll">
      <perfect-scrollbar
        class="scroll-area"
        :settings="settings"
        @ps-scroll-y="scrollHanle"
      >
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <li class="menu-title"><span>Menú</span></li>
            <li :class="{ active: isActive('/admin/principal') }">
              <router-link to="/admin/principal"
                ><i class="feather feather-home"></i> <span>Bienvenido</span></router-link
              >
            </li>
            <li class="menu-title"><span>Mantenimientos Páginas</span></li>
            <li :class="{ active: isActive(['/admin/inicio']) }">
              <router-link to="/admin/inicio"
                ><i class="feather feather-copy"></i> <span>Inicio</span></router-link
              >
            </li>
            <li :class="{ active: isActive('/admin/nuestra-cultura') }">
              <router-link to="/admin/nuestra-cultura"
                ><i class="feather feather-file-minus"></i>
                <span>Nuestra Cultura</span></router-link
              >
            </li>
            <li :class="{ active: isActive('/admin/colaboradores') }">
              <router-link to="/admin/nuestros-colaboradores"
                ><i class="feather feather-file-minus"></i>
                <span>Nuestros Colaboradores</span></router-link
              >
            </li>
            <li :class="{ active: isActive('/admin/escuela-corporativa') }">
              <router-link to="/admin/escuela-corporativa"
                ><i class="feather feather-file-minus"></i>
                <span>Escuela Corporativa</span></router-link
              >
            </li>
            <li :class="{ active: isActive('/admin/young-talent') }">
              <router-link to="/admin/young-talent"
                ><i class="feather feather-award"></i>
                <span>Young Talent</span></router-link
              >
            </li>
            <li class="menu-title"><span>Mantenimientos</span></li>
            <li :class="{ active: isActive('/admin/ofertas-laborales') }">
              <router-link to="/admin/ofertas-laborales"
                ><i class="feather feather-clipboard"></i>
                <span>Ofertas Laborales</span></router-link
              >
            </li>
<!--            <li :class="{ active: isActive('/admin/usuarios-sistema') }">-->
<!--              <router-link to="/admin/usuarios-sistema"-->
<!--                ><i class="feather feather-user-check"></i>-->
<!--                <span>Usuarios Sistema</span></router-link-->
<!--              >-->
<!--            </li>-->
            <li class="menu-title"><span>Reportes</span></li>
            <li :class="{ active: isActive('/admin/reporte-por-estado') }">
              <router-link to="/admin/reporte-por-estado"
                ><i class="feather feather-bar-chart"></i>
                <span>Ofertas por estado</span></router-link
              >
            </li>
            <li :class="{ active: isActive('/admin/reporte-por-responsable') }">
              <router-link to="/admin/reporte-por-responsable"
                ><i class="feather feather-bar-chart"></i>
                <span>Ofertas por responsable</span></router-link
              >
            </li>
            <li :class="{ active: isActive('/admin/postulantes-por-proceso') }">
              <router-link to="/admin/postulantes-por-proceso"
                ><i class="feather feather-bar-chart"></i>
                <span>Postulantes por proceso</span></router-link
              >
            </li>
            <li :class="{ active: isActive('/admin/reporte-personas-registradas') }">
              <router-link to="/admin/reporte-personas-registradas"
                ><i class="feather feather-bar-chart"></i>
                <span>Personas registradas</span></router-link
              >
            </li>
            <li :class="{ active: isActive('/admin/reporte-por-postulaciones') }">
              <router-link to="/admin/reporte-por-postulaciones"
                ><i class="feather feather-bar-chart"></i>
                <span>Postulantes por convocatoria</span></router-link
              >
            </li>  
          </ul>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
  <!-- /Sidebar -->
</template>
<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
export default {
  data() {
    return {
      settingMenu: false,
      settings: {
        suppressScrollX: true,
      },
      activeClass: "active",
    };
  },
  methods: {
    scrollHanle(evt) {},
    isActive(paths) {
      return paths.includes(this.$route.path);
    },
    isActiveForm(paths) {
      return paths.includes(this.$route.path);
    },
    toggleformsMenu() {
      this.formsMenuData = !this.formsMenuData;
    },
    toggletablesMenu() {
      this.tablesMenuData = !this.tablesMenuData;
    },
    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector("#sidebar")) {
          let a = document
            .querySelector("#sidebar")
            .querySelector('[href="' + ele + '"]');

          if (a) {
            a.classList.add("active");
            let parentCollapseDiv = a.closest(".collapse.menu-dropdown");
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show");
              parentCollapseDiv.parentElement.children[0].classList.add("active");
              parentCollapseDiv.parentElement.children[0].setAttribute(
                "aria-expanded",
                "true"
              );
              if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement
                  .closest(".collapse")
                  .classList.add("show");
                if (
                  parentCollapseDiv.parentElement.closest(".collapse")
                    .previousElementSibling
                )
                  parentCollapseDiv.parentElement
                    .closest(".collapse")
                    .previousElementSibling.classList.add("active");
              }
            }
          }
        }
      }, 1000);
    },
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
    formsMenu() {
      return (
        this.$route.name == "/admin/form-basic-inputs" ||
        this.$route.name == "/admin/form-input-groups" ||
        this.$route.name == "/admin/form-horizontal" ||
        this.$route.name == "/admin/form-vertical" ||
        this.$route.name == "/admin/form-mask" ||
        this.$route.name == "/admin/form-validation"
      );
    },
    tablesMenu() {
      return (
        this.$route.name == "/admin/data-tables" ||
        this.$route.name == "/admin/tables-basic"
      );
    },
  },
  components: {
    PerfectScrollbar,
  },
};
</script>

<style>

</style>
